module.exports = __webpack_public_path__ + "media/images/spratt-111762b0793e3f094f70995b6e23ada1.jpg";